import QuestionsLoanForgivenessTeacher from 'tio-employee/components/questions/loan-forgiveness/teacher';

<template><QuestionsLoanForgivenessTeacher /></template>
